import { useEffect, useState } from 'react';

const query = (q) => (typeof window !== 'undefined' && window.matchMedia ? window.matchMedia(q) : null);

/** True while the media query matches. */
export const useMediaQuery = (q) => {
  const [matches, setMatches] = useState(() => Boolean(query(q)?.matches));
  useEffect(() => {
    const media = query(q);
    if (!media) return undefined;
    const onChange = () => setMatches(media.matches);
    onChange();
    media.addEventListener('change', onChange);
    return () => media.removeEventListener('change', onChange);
  }, [q]);
  return matches;
};

// Tailwind breakpoints used by the layout.
export const useIsDesktop = () => useMediaQuery('(min-width: 1024px)'); // lg
export const useIsWide = () => useMediaQuery('(min-width: 1280px)'); // xl
